import { render, staticRenderFns } from "./TumblerProp.vue?vue&type=template&id=20e32548&"
import script from "./TumblerProp.vue?vue&type=script&lang=js&"
export * from "./TumblerProp.vue?vue&type=script&lang=js&"
import style0 from "./TumblerProp.vue?vue&type=style&index=0&id=20e32548&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports